module.exports = __webpack_public_path__ + "static/media/efiling-logotype-d.837884d8.svg";